import type { HeroAnimationFacing } from './render-snapshot';

export type HeroActionClip = 'attack' | 'block' | 'dodge';
export const HERO_ACTION_SOURCE_FRAME_COUNT = 8;
export const ACTION_PREVIEW_HOLD_MS = 400;
const attack = { sourceFrames: [0, 1, 2, 3, 5, 6, 7],
  frameDurationsMs: [160, 160, 160, 220, 70, 70, 120], durationMs: 960 } as const;
const northAttack = { sourceFrames: attack.sourceFrames,
  frameDurationsMs: [160, 160, 160, 220, 100, 100, 120], durationMs: 1020 } as const;
const defense = { sourceFrames: [0, 1, 2, 3, 4, 5, 6, 7],
  frameDurationsMs: [112.5, 112.5, 112.5, 112.5, 112.5, 112.5, 112.5, 112.5], durationMs: 900 } as const;
/** Scheduling only: all source images stay whole and unchanged. */
export function heroActionTimeline(clip: HeroActionClip, facing: HeroAnimationFacing = 'east') {
  return clip === 'attack' ? facing === 'north' ? northAttack : attack : defense;
}
export function heroActionSourceFrameAt(clip: HeroActionClip, elapsedMs: number, facing: HeroAnimationFacing = 'east'): number {
  const timeline = heroActionTimeline(clip, facing), elapsed = Math.max(0, elapsedMs);
  let end = 0;
  for (let index = 0; index < timeline.sourceFrames.length; index++) {
    end += timeline.frameDurationsMs[index]!;
    // Progress round-trips must pick the same pose at an exact millisecond boundary.
    if (elapsed + 0.0000001 < end) return timeline.sourceFrames[index]!;
  }
  return timeline.sourceFrames[timeline.sourceFrames.length - 1]!;
}
export function heroActionSourceFrame(clip: HeroActionClip, progress: number, facing: HeroAnimationFacing = 'east'): number {
  return heroActionSourceFrameAt(clip, Math.max(0, Math.min(1, progress)) * heroActionTimeline(clip, facing).durationMs, facing);
}
